// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class TabHeaderModule extends ModuleBase {
  @Prop({ default: "ErrorWidget" })
  public type!: string;

  public activeTab: string = "#tab1";

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  public created() {
    if (this.instance["tabs"]) {
      let arTabs = this.instance["tabs"].slice();
      if (arTabs.length) {
        this.activeTab = arTabs[0]["id"];
      }
    }
  }
}
